import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import isEmpty from "../../../common/helpers/isEmpty";
import useIsLoading from "../../../hooks/useIsLoading";
import { selectWorkHistorySummary } from "../../workHistory/WorkHistoriesSlice";
import { WorkLocationSummary } from "../../workHistory/types/queries";
import TalentSummaryCard from "./TalentSummaryCard";
import EmptyStateText from "./EmptyStateText";

const TalentEezyWorkExperience = () => {
  const { t } = useTranslation("talentProfile");
  const workLocationSummary = useAppSelector(selectWorkHistorySummary);
  const isLoading = useIsLoading(["workHistories.summary"]);

  const showEmptyState = !isLoading && isEmpty(workLocationSummary);
  const showResults = !isLoading && !isEmpty(workLocationSummary);

  return (
    <TalentSummaryCard title={t("profileSummary.workExperienceAtEezy")}>
      <>
        {showResults && (
          <Box display="flex" flexWrap="wrap">
            {workLocationSummary.map((summary: WorkLocationSummary) => (
              <Box
                key={summary.workLocationId ?? summary.workLocationName}
                mb={1}
                display="flex"
                gap="8px"
                alignItems="center"
              >
                <Typography
                  sx={{ wordBreak: "break-word" }}
                  key={summary.workLocationId ?? summary.workLocationName}
                >
                  {summary.workLocationName}
                </Typography>
                <Chip
                  sx={{
                    "& .MuiChip-label": {
                      padding: "0px 6.5px 0px 6.5px",
                    },
                    height: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                    borderRadius: "64px",
                    marginBottom: 0,
                    marginRight: "16px",
                  }}
                  label={`${summary.dayCount} ${t("common:dayShort")}`}
                  variant="filled"
                />
              </Box>
            ))}
          </Box>
        )}
        {showEmptyState && <EmptyStateText />}
      </>
    </TalentSummaryCard>
  );
};

export default TalentEezyWorkExperience;
